import React, { useState, useEffect, useRef } from "react";
// import "./invoice.css";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import Santlogo from "../../../Assets/SantGollogo.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import PdfPreview from "../../../Common/PDFPreview";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import "../../../Common/Fonts/Signika-Bold-normal";
import "../../../Common/Fonts/Signika-Regular-normal";
import "../../../Common/Fonts/Signika-Medium-normal";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";


const API_URL = process.env.REACT_APP_API;

const AwakentryReport = ({ Doc_No, disabledFeild }) => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [invoiceData, setInvoiceData] = useState([]);
    const [pdfPreview, setPdfPreview] = useState(null);
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")


    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/generating_AwakEntry_report?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${Doc_No}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            setInvoiceData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = async (data) => {

        const pdf = new jsPDF({ orientation: "portrait" });
        const allData = data?.[0] || {};

        const docDate = new Date(allData.doc_date);
        const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

        // const displayCompanyName =
        //   docDate < cnameUpdatedDate
        //     ? newCompanyName
        //     : allData.Company_Name_E;


        const logoToUse = docDate < cnameUpdatedDate ? Santlogo : Santlogo;
        const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
        const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : allData.AL1;

        pdf.setFont("Signika-Regular");
        pdf.setFontSize(8);

        const logoImg = new Image();
        const signImg = new Image();
        // const headerImg = new Image();
        const footerImg = new Image();
        const footerImg1 = new Image();
        logoImg.src = Santlogo;
        // signImg.src = SignToUse;
        // headerImg.src = HeaderJK;
        // footerImg.src = FooterJK;
        // footerImg1.src = FooterJK1

        const qrCodeData = `
    GSTN of Supplier : ${allData.companyGSTNo || ""}
    GSTIN of Buyer : ${allData.billtogstno || ""}
    Document No. : ${allData.doc_no || ""}
    Document Type : Awak Print
    Date : ${allData.doc_date || ""}
    HSN : ${allData.HSN || ""}
    IRN : ${allData.einvoiceno || ""}
    `;
        const qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());

        logoImg.src = logoToUse;
        logoImg.onload = () => {

            const shouldUseImage =
                // docDate >= cnameUpdatedDate

                pdf.addImage(logoImg, "PNG", 12, 2, 25, 25);
            pdf.setFont("Signika-Bold");
            //   pdf.setFontSize(14);
            //   pdf.text(displayCompanyName, 45, 14);
            //   pdf.setFont("Signika-Regular");
            //   pdf.setFontSize(9);
            // pdf.setFont("Signika-Regular"); 
            //   pdf.setFontSize(9);
            //   pdf.text(`${foormerlyName}`, 45, 18);
            //   pdf.text(`${allData.AL2}`, 45, 22);
            //   pdf.text(`${allData.AL3}`, 45, 26);
            //   pdf.text(`${allData.AL4}`, 45, 30);
            //   pdf.text(`${allData.Other}`, 45, 34);
            //   pdf.text(`${allData.BillFooter}`,45,38)
            if (shouldUseImage) {
                // Use header image across top (new template)
                // pdf.addImage(headerImg, "PNG", 0, 6, 180, 34); // full width
            } else {
                // Old layout: logo + company name + address lines
                pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                pdf.setFont("Signika-Bold");
                // pdf.setFontSize(14);
                // // pdf.text(displayCompanyName, 45, 14);
                // pdf.setFont("Signika-Regular");
                // pdf.setFontSize(9);
                // pdf.text(`${foormerlyName}`, 45, 18);
                // pdf.text(`${allData.AL2}`, 45, 22);
                // pdf.text(`${allData.AL3}`, 45, 26);
                // pdf.text(`${allData.AL4}`, 45, 30);
                // pdf.text(`${allData.Other}`, 45, 34);
                // pdf.text(`${allData.BillFooter}`, 45, 38);
            }
            // pdf.addImage(qrCodeDataUrl, "PNG", 170, 9, 30, 30);
            pdf.text("By Laws No 18 & 52, Schedule No 18 Bill", 105, 12, { align: "center" });
            // ======= CUSTOM HEADER WITHOUT IMAGE =======
            pdf.setFont("Signika-Medium");
            pdf.setFontSize(16);
            pdf.setTextColor(0, 0, 0);


            // Center the text header
            pdf.text("Sangli Krushi Utappan Bazar Samiti , Sangli", 105, 18, { align: "center" });

            // Optional: small subtitle
            pdf.setFont("Signika-Regular");
            pdf.setFontSize(10);

            const drawPageHeader = () => {
                // ======= LOGO =======
                if (logoImg) {
                    pdf.addImage(logoImg, "PNG", 12, 8, 22, 22); // x,y,w,h
                    pdf.setFont("Signika-Bold");
                }

                // ======= TOP TITLE =======
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(10);
                pdf.text(
                    "By Laws No 18 & 52, Schedule No 18 Bill",
                    105,
                    12,
                    { align: "center" }
                );

                // ======= MAIN HEADING =======
                pdf.setFont("Signika-Medium");
                pdf.setFontSize(16);
                pdf.setTextColor(0, 0, 0);

                pdf.text(
                    "Sangli Krushi Utappan Bazar Samiti , Sangli",
                    105,
                    18,
                    { align: "center" }
                );

                // ======= SUBTITLE =======
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(10);
                // pdf.text(
                //     "Government Licensed Agricultural Market Committee",
                //     105,
                //     24,
                //     { align: "center" }
                // );

                // Reset text color for table
                pdf.setTextColor(0, 0, 0);

                // Set starting Y below header
                y = 34;
            };





            pdf.setFontSize(10);
            pdf.setFont("Signika-Bold");
            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.line(10, 27, 200, 27);
            pdf.setTextColor(41, 122, 14);
            pdf.text("Awak Print", 95, 33);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Awak No: ${allData.Doc_No}`, 12, 33);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Awak Date: ${allData.Doc_Date}`, 165, 33);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, 37, 200, 37);
            pdf.setTextColor(0, 0, 0);

            const drawInvoiceHeader = () => {

                const pageWidth = pdf.internal.pageSize.getWidth();

                pdf.setFontSize(10);
                pdf.setFont("Signika-Bold");

                pdf.setDrawColor(80, 80, 80);
                pdf.setLineWidth(0.3);

                // Top line
                pdf.line(10, 31, pageWidth - 10, 31);

                // Title
                pdf.setTextColor(41, 122, 14);
                pdf.text("Awak Print", pageWidth / 2 - 10, 37);

                // Bill details
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);

                pdf.text(`Bill No: ${allData.doc_no}`, 12, 37);
                pdf.text(`Bill Date: ${allData.doc_date}`, pageWidth - 45, 37);

                // Bottom line
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, 40, pageWidth - 10, 40);

                return 30;   // 👉 y-position where next content starts
            };


            let y = 25;
            pdf.setFontSize(9);

            const fieldPairs = [
                [
                    `Company Name. :${allData.Company_Name_E}`,
                    ``,
                    `PAN NO. : ${allData.Pan_No}`,
                ],
                [
                    `ADDRESS : ${allData.Address_E}`,
                    ``,
                    `PHONE NO : (0233)2670614,${allData.PHONE}`,
                ],
                [
                    ``,
                    ``,
                    ``,
                ],
                [
                    ``,
                    "",
                    ``,
                ],
                [
                    ``,
                    "",
                    ``,
                ],
                ["", "", "", ""],
            ];

            fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {
                const leftX = 12;
                const middleX = 60;
                const rightX = 110;
                const wrapWidth = 85;
                const lineHeight = 4;

                const [rawLeftLabel, ...rawLeftValParts] = (left1 ?? "").split(":");
                const leftLabel = rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}` : "";
                const leftValue = rawLeftValParts.join("").trim();
                const leftValueLines = pdf.splitTextToSize(leftValue, wrapWidth - pdf.getTextWidth(leftLabel));

                const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                const rightLabelText = rightLabel?.trim() ? `${rightLabel.trim()}` : "";
                const rightValueText = rightValue?.toString().trim() ?? "";
                const rightValueLines = pdf.splitTextToSize(rightValueText, wrapWidth - pdf.getTextWidth(rightLabelText));

                const maxLines = Math.max(leftValueLines.length, left2Lines.length, rightValueLines.length);

                for (let i = 0; i < maxLines; i++) {
                    const yOffset = y + i * lineHeight + 17;

                    if (i === 0 && leftLabel) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(leftLabel, leftX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i] ?? "", leftX + pdf.getTextWidth(leftLabel) + 1, yOffset);
                    } else if (leftValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i], leftX, yOffset);
                    }


                    if (left2Lines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(left2Lines[i], middleX, yOffset);
                    }

                    if (i === 0 && rightLabelText) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(rightLabelText, rightX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i] ?? "", rightX + pdf.getTextWidth(rightLabelText) + 1, yOffset);
                    } else if (rightValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i], rightX, yOffset);
                    }
                }

                y += maxLines * lineHeight;
            });

            const drawFieldPairs = () => {

                const leftX = 12;
                const middleX = 60;
                const rightX = 110;
                const wrapWidth = 85;
                const lineHeight = 4;

                const fieldPairs = [
                    [
                        `Company Name. :${allData.Company_Name_E}`,
                        ``,
                        `PAN NO. : ${allData.Pan_No}`,
                    ],
                    [
                        `ADDRESS : ${allData.Address_E}`,
                        ``,
                        `PHONE NO : (0233)2670614,${allData.PHONE}`,
                    ],
                    [
                        ``,
                        ``,
                        ``,
                    ],
                    [
                        ``,
                        "",
                        `Truck no: ${allData.Truck_No}`,
                    ],
                    [
                        ``,
                        "",
                    ],
                    ["", "", "", ""],
                ];

                fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {

                    const [rawLeftLabel, ...rawLeftValParts] =
                        (left1 ?? "").split(":");

                    const leftLabel =
                        rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}` : "";

                    const leftValue = rawLeftValParts.join("").trim();

                    const leftValueLines = pdf.splitTextToSize(
                        leftValue,
                        wrapWidth - pdf.getTextWidth(leftLabel)
                    );

                    const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                    const rightLabelText =
                        rightLabel?.trim() ? `${rightLabel.trim()}` : "";

                    const rightValueText = rightValue?.toString().trim() ?? "";

                    const rightValueLines = pdf.splitTextToSize(
                        rightValueText,
                        wrapWidth - pdf.getTextWidth(rightLabelText)
                    );

                    const maxLines = Math.max(
                        leftValueLines.length,
                        left2Lines.length,
                        rightValueLines.length
                    );

                    for (let i = 0; i < maxLines; i++) {

                        const yOffset = y + i * lineHeight + 17;

                        // LEFT label + value
                        if (i === 0 && leftLabel) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(leftLabel, leftX, yOffset);

                            pdf.setFont("Signika-Regular");
                            pdf.text(
                                leftValueLines[i] ?? "",
                                leftX + pdf.getTextWidth(leftLabel) + 1,
                                yOffset
                            );
                        } else if (leftValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(leftValueLines[i], leftX, yOffset);
                        }

                        // MIDDLE text
                        if (left2Lines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(left2Lines[i], middleX, yOffset);
                        }

                        // RIGHT label + value
                        if (i === 0 && rightLabelText) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(rightLabelText, rightX, yOffset);

                            pdf.setFont("Signika-Regular");
                            pdf.text(
                                rightValueLines[i] ?? "",
                                rightX + pdf.getTextWidth(rightLabelText) + 1,
                                yOffset
                            );
                        } else if (rightValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(rightValueLines[i], rightX, yOffset);
                        }
                    }

                    y += maxLines * lineHeight;
                });

                // return next y after block
                return y;
            };


            const verticalX = 105;
            const topOfFieldPairs = 59;
            const bottomOfFieldPairs = y + 12;

            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            function drawBuyerSection(pdf, billToLines, y) {
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, y - 1, 200, y - 1);

                const addressStartY = y - 5;

                const endYBill = addressBlock(
                    12,
                    addressStartY,
                    "",
                    billToLines
                );

                return endYBill + 4;
            }


            const addressBlock = (x, yStart, title, lines) => {
                let y = yStart;
                const lineHeight = 4; // space between lines

                // Draw title
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);
                pdf.text(title, x, y + 10);
                y += lineHeight + 10;

                // Compute maximum label width
                const labelWidth = Math.max(
                    ...lines.map(line => {
                        const [label] = line.split(":");
                        return pdf.getTextWidth(label.trim());
                    })
                );

                // Draw lines
                lines.forEach((line) => {
                    const [label, ...valueParts] = line.split(":");
                    const value = valueParts.join(":").trim();

                    // Draw label
                    pdf.setFont("Signika-Bold");
                    pdf.setTextColor(41, 122, 14); // green color for labels
                    pdf.text(label.trim() + ":", x, y);

                    // Draw value starting at fixed position
                    pdf.setFont("Signika-Regular");
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(value, x + labelWidth + 2, y); // 2 units padding

                    y += lineHeight;
                });

                return y; // return updated y
            };



            const isRegular =
                allData.carporateSaleDoc !== 0 &&
                allData.carporateSaleDoc !== "" &&
                allData.selling_type === "P" &&
                allData.Delivery_type === "C";

            const fssaiNo = isRegular
                ? allData.FSSAI_BillTo
                : allData.carporateBillToFSSAI || allData.FSSAI_BillTo;

            const tanNo = isRegular
                ? allData.BillToTanNo
                : allData.Carporate_Tanno || allData.BillToTanNo;

            const billToLines = [
                `Farmer Name: ${isRegular
                    ? allData.FarmerName
                    : allData.FarmerName || allData.FarmerName}`,


                `Farmer Address: ${isRegular
                    ? allData.FarmerAddress
                    : allData.FarmerAddress}`,

                // `City: ${isRegular
                //     ? `${allData.billtopin}`
                //     : allData.CustomerCityName
                //         ? `${allData.CustomerCityName}  `
                //         : `${allData.billtopin}`
                // }`,
                // `GST: ${isRegular
                //     ? allData.billtogstno
                //     : allData.CarporateBillToGst_No || allData.billtogstno
                // }`,

                // `PAN: ${isRegular
                //     ? allData.billtopanno
                //     : allData.Carporate_Pan || allData.billtopanno
                // }`,

                fssaiNo ? `FSSAI: ${fssaiNo}` : null,
                tanNo ? `TAN: ${tanNo}` : null,
            ].filter(Boolean);

            const fssaiShipTo = allData.FSSAI_ShipTo;
            const tanShipTo = allData.ShipToTanNo;

            const shipToLines = [
                `Truck No: ${allData.Truck_No}`,
                `Mobile No: ${allData.mobile}`,
                // `City: ${allData.shiptocityname} (${allData.shiptocitystate} - ${allData.shiptogststatecode})`,
                // `GST: ${allData.shiptogstno}`,
                // `PAN: ${allData.shiptopanno}`,
                // fssaiShipTo ? `FSSAI: ${fssaiShipTo}` : null,
                // tanShipTo ? `TAN: ${tanShipTo}` : null,
            ].filter(Boolean); // removes null/undefined/empty

            const pageHeight = pdf.internal.pageSize.getHeight();
            const bottomMargin = 40;   // space for totals + footer



            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y - 1, 200, y - 1);

            const addressStartY = y - 5;
            // setTextColor(0, 0, 0)
            const endYBill = addressBlock(12, addressStartY, "", billToLines);
            const endYShip = addressBlock(110, addressStartY, "", shipToLines);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(105, addressStartY + 6, 105, Math.max(endYBill, endYShip) + 7);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(
                10,
                Math.max(endYBill, endYShip) + 10,
                200,
                Math.max(endYBill, endYShip) + 10
            );
            y = Math.max(endYBill, endYShip) + 8;

            const verticalStartAfterGap = addressStartY + 15;
            const verticalEnd = Math.max(endYBill, endYShip);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(105, verticalStartAfterGap + 50, 105, verticalEnd + 8);





            const drawTableHeader = () => {
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(
                    10,
                    Math.max(endYBill, endYShip) + 10,
                    200,
                    Math.max(endYBill, endYShip) + 10
                );
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(41, 122, 14);

                pdf.text("Id", 12, y);
                pdf.text("Farmer Name", 27, y);
                pdf.text("Item Name", 75, y);
                pdf.text("Quantity", 112, y);
                // pdf.text("Net Weight", 135.5, y);
                // pdf.text("Rate", 165.5, y);
                pdf.text("Value", 189, y);

                pdf.setTextColor(0, 0, 0);

                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                // pdf.line(10, y + 4, 200, y + 4);
                pdf.line(10, y + 2, 200, y + 2);

                y += 6;
            };

            const HEADER_CONTENT_GAP = 50;


            const addNewPage = () => {

                pdf.addPage();

                // draw top invoice header
                y = drawInvoiceHeader();
                drawFieldPairs();
                y = drawBuyerSection(pdf, billToLines, y);

                // optional page sub-header (address / party etc.)
                drawPageHeader();

                // add spacing gap before table header
                y += HEADER_CONTENT_GAP;

                // finally draw table header
                drawTableHeader();
            };



            // pdf.setLineWidth(0.3);
            // pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 5, 200, y + 5);



            const amountX = 187;


            y += 6; // space below header
            drawTableHeader();

            const ROW_HEIGHT = 4; // base row height
            const ROW_SPACING = 2; // space between rows
            const poweredByY = 292; // fixed row height like first page
            const ROWS_PER_PAGE = 15;


            let rowsOnPage = 0;

            (data || []).forEach((item) => {
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);

                const farmerText = item.FarmerName?.trim() || "Sugar";
                const wrappedFarmer = pdf.splitTextToSize(farmerText, 45);
                const wrappedItem = pdf.splitTextToSize(String(item.System_Name_E ?? ""), 50);

                const rowHeight = ROW_HEIGHT * Math.max(wrappedFarmer.length, wrappedItem.length);

                // Page break check: either max rows reached OR space exceeded before footer
                if (rowsOnPage >= ROWS_PER_PAGE || y + rowHeight + ROW_SPACING > poweredByY - 30) {
                    pdf.setLineWidth(0.3);
                    pdf.setDrawColor(80, 80, 80);
                    pdf.line(10, y + 5, 200, y + 5);
                    addNewPage(); // resets y and draws header
                    rowsOnPage = 0; // reset counter for new page
                }

                // Draw row (use fixed row height for spacing)
                pdf.setFont("Signika-Medium");
                pdf.text(String(item.detail_id ?? ""), 15, y, { align: "right" });
                pdf.text(wrappedFarmer, 27, y);

                pdf.setFont("Signika-Regular");
                pdf.text(wrappedItem, 75, y);

                const value = parseFloat(item.Amount || 0);
                const rate = parseFloat(item.Salerate || 0);

                const formattedQty = Number(item.Awak_Qty || 0)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });
                const formattedRate = Number(rate)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });
                const formattedValue = Number(value)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2 });

                // pdf.text(String(item.Net_weight ?? ""), 151, y, { align: "right" });
                pdf.text(`${formattedQty}`, 124, y, { align: "right" });
                // pdf.text(formattedRate, 172, y, { align: "right" });
                pdf.text(formattedValue, 197, y, { align: "right" });

                //Line  After Each Row
                // pdf.setLineWidth(0.3);
                // pdf.setDrawColor(80, 80, 80);
                // // pdf.line(10, y + 4, 200, y + 4);
                // pdf.line(10, y - 4, 200, y - 4);

                y += rowHeight + ROW_SPACING; // move to next row
                rowsOnPage++;
            });


            // pdf.setLineWidth(0.3);
            // pdf.setDrawColor(80, 80, 80);
            // // pdf.line(10, y + 4, 200, y + 4);
            // pdf.line(10, y - 4, 200, y - 4);



            const lineHeight = 5;
            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);

            pdf.text("Total", 12, y);

            // Totals from your data object (alldata)
            const totalQty = Number(allData.AwakQty || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            const totalWeight = Number(allData.HeadNtWt || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            // const totalValue = Number(allData.SubTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            let totalAmount = 0;

            (data || []).forEach((row) => {
                totalAmount += Number(row.Amount || 0);
            });

            // pdf.text(totalWeight, 151, y, { align: "right" });       // Net Weight
            pdf.text(`${totalQty}`, 125, y, { align: "right" }); // Quantity
            pdf.text(totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 }), 197, y, { align: "right" }); // Value

            const ensureSpace = (neededHeight) => {
                const pageHeight = pdf.internal.pageSize.getHeight();
                const bottomLimit = pageHeight - 30;   // leave space for footer

                if (y + neededHeight > bottomLimit) {
                    pdf.addPage();
                    y = 40;
                    y = drawInvoiceHeader();
                    drawFieldPairs();
                    y = drawBuyerSection(pdf, billToLines, y);

                    // optional page sub-header (address / party etc.)
                    drawPageHeader();

                    // add spacing gap before table header
                    y += HEADER_CONTENT_GAP;

                }
            };


            // Draw line above totals

            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 4, 200, y + 4);
            pdf.line(10, y - 4, 200, y - 4);

            // Optional: line under totals
            pdf.line(10, y + 2, 200, y + 2);

            y += lineHeight;
            ensureSpace(60);

            // const containerAmt = Number(allData.Container || 0);

            // pdf.setFont("Signika-Regular");
            // pdf.text("Container:", 130, y + 6, { align: "left" });
            // pdf.text(
            //     formatReadableAmount(containerAmt),
            //     197,
            //     y + 6,
            //     { align: "right" }
            // );


            // pdf.setFont("Signika-Bold");

            // const subTotalWithContainer =
            //     Number(allData.SubTotal || 0) + containerAmt;

            // pdf.text("Total + Container:", 130, y + 11);
            // pdf.text(
            //     formatReadableAmount(subTotalWithContainer),
            //     197,
            //     y + 11,
            //     { align: "right" }
            // );




            y += 8; // move cursor below totals if needed


            pdf.setFont("Signika-Regular");


            let currentY = y + 16;


            let fssai = String(allData.MillFSSAI_No ?? "").trim();
            if (fssai !== "") {
                // Manually insert breakable characters every 15 chars if needed
                if (fssai.length > 25 && !fssai.includes(" ")) {
                    fssai = fssai.match(/.{1,20}/g).join(" ");
                }

                const wrappedFSSAI = pdf.splitTextToSize(fssai, 100);
                pdf.text("Mill FSSAI:", 12, currentY);
                pdf.text(wrappedFSSAI, 28, currentY);
            }



            y += 10;

            // 1. Parse out your rates / amounts
            const igstRate = parseFloat(allData.IGSTRate) || 0;
            const igstAmt = parseFloat(allData.IGSTAmount) || 0;

            const cgstRate = parseFloat(allData.CGSTRate) || 0;
            const cgstAmt = parseFloat(allData.CGSTAmount) || 0;

            const sgstRate = parseFloat(allData.SGSTRate) || 0;
            const sgstAmt = parseFloat(allData.SGSTAmount) || 0;

            const taxRows = [];

            if (igstRate > 0) {
                // only IGST
                taxRows.push(["IGST", igstRate, igstAmt]);
            } else {
                taxRows.push(
                    //   ["CGST", cgstRate, cgstAmt],
                    //   ["SGST", sgstRate, sgstAmt]

                );
            }
            const isMarketCessApplicable = allData.MarketCess === "Y";

            const summaryFields = [
                ...(allData.carporateSaleDoc === 0 ||
                    allData.carporateSaleDoc === "" ||
                    allData.carporateSaleDoc === null
                    ? [["Freight", allData.LESS_FRT_RATE, allData.freight]]
                    : []),

                // ["Taxable Amount", "", allData.SubTotal],
                ...taxRows,
                ["Leavy", "", allData.Leavy],
                ["Commission", "", allData.Commission],
                ["Round Off", "", allData.RoundOff],

                ...(isMarketCessApplicable
                    ? [
                        ["Market Cess", "", allData.HeadMarketcess],
                        ["Dekrekh Fee", "", allData.DekhRekh],
                    ]
                    : []
                ),

            ];


            let headingAdded = false; // ✅ to ensure heading appears only once

            // summaryFields.forEach(([label, rate, amount]) => {
            //     // Add heading before "Taxable Amount" group
            //     if (!headingAdded && ["Taxable Amount", "Leavy", "Commission", "Market Cess", "Dekrekh"].includes(label)) {
            //         pdf.setFont("Signika-Medium");
            //         pdf.setTextColor(41, 122, 14);
            //         pdf.text("Other Expenses", 130, y);
            //         pdf.text("Amount", 197, y, { align: "right" });
            //         y += 4; // space below heading
            //         headingAdded = true;
            //     }

            //     // Draw each summary row
            //     pdf.setFont("Signika-Regular");
            //     pdf.setTextColor(0, 0, 0);

            //     pdf.text(`${label}:`, 130, y + 3);

            //     // Rate column (if exists)
            //     if (rate !== null && rate !== undefined && rate !== "") {
            //         pdf.text(`${formatReadableAmount(rate)}%`, 165, y + 3, { align: "center" });
            //     }

            //     // Amount (formatted)
            //     const formattedAmount = formatReadableAmount(amount);
            //     pdf.text(formattedAmount, 197, y + 3, { align: "right" });

            //     y += 5;
            // });




            // pdf.setLineWidth(0.3);
            // pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 4, 200, y + 4);

            // const totalAmount =
            //     Number(allData.Leavy || 0) +
            //     Number(allData.Commission || 0) +
            //     (isMarketCessApplicable
            //         ? Number(allData.HeadMarketcess || 0) +
            //         Number(allData.DekhRekh || 0)
            //         : 0);
            // Number(allData.MarketCess || 0) +
            // Number(allData.DekhRekh || 0);

            // const formattedTotal = formatReadableAmount(totalAmount);

            // pdf.setFont("Signika-Bold");
            // pdf.setTextColor(41, 122, 14);
            // pdf.text("Total Expenses:", 150, y + 9);
            // pdf.text(`₹ ${formattedTotal}`, amountX + 10, y + 9, { align: "right" });

            y += 5;
            pdf.setLineWidth(0.3);
            // pdf.line(10, y + 7, 200, y + 7);

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);
            pdf.setFontSize(8);
            // pdf.text("Terms & Conditions:", 12, y + 12);
            // pdf.setFont("Signika-Regular");
            // const notes = [
            //     "- If there is no insurance of the goods, after dispatch from the destination,",
            //     "   we are not responsible for non delivery, damage or any kind of loss.",
            //     "- Buyer must inspect and confirm quality & quantity of the goods before dispatch from godown.",
            //     "   Once loaded and truck leaves godown, Said all responsibilities will be transfer to buyers account.",
            //     "- Please send the full amount in our account through RTGS before despatch the goods.",
            //     "   If the amount is not received in our account, Interest of 24% P.A. will be charged to the buyer.",
            //     `- Subject to ${allData.companyCity} jurisdiction.`
            // ];
            // notes.forEach((n, i) => pdf.text(n, 12, y + 13 + (i + 1) * 3));

            y += 25;
            const summaryY = poweredByY - 30;
            if (allData.SBNarration) {
                pdf.text(`${allData.SBNarration}`, 12, y + 12)
            }
            const signY = y - 10;
            pdf.setFont("Signika-Bold");
            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);

            const signWidth = 240;
            const signHeight = signWidth / 5;

            y -= 80;

            const billY = y + 68;      // Bill Amount Y
            const payableY = y + 75;   // Payable Y

            // Draw LINE ABOVE Bill Amount
            // pdf.setLineWidth(0.3);
            // pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, billY + 2, 200, billY + 2);



            const dekhRekhAmt = isMarketCessApplicable
                ? Number(allData.DekhRekh || 0)
                : 0;

            const marketCessAmt = isMarketCessApplicable
                ? Number(allData.HeadMarketcess || 0)
                : 0;

            const baseBillAmount = Number(allData.SubTotal || 0)
                + Number(allData.Leavy || 0)
                + Number(allData.Commission || 0);

            const finalBillAmount = baseBillAmount + dekhRekhAmt + marketCessAmt;


            // pdf.addImage(signImg, "PNG", 157, y + 11, signWidth, signHeight);
            // pdf.setFont("Signika-Medium");
            // pdf.text("Bill Amount", 150, y + 75);

            // // Value (right-aligned exactly like Amount column)
            // pdf.text(
            //     Number(finalBillAmount || 0).toLocaleString("en-IN", {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }),
            //     197,
            //     y + 75,
            //     { align: "right" }
            // );

            // const totalInWords = ConvertNumberToWord(
            //     (finalBillAmount)
            // );
            // pdf.text(`Rs: ${totalInWords}.`, 12, y + 75);
            // const Total = Number(finalBillAmount || 0).toLocaleString(
            //     "en-IN",
            //     {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }
            // );

            // pdf.line(10, payableY + 3, 200, payableY + 3);

            // pdf.text("Payable", 150, y + 85);

            // // Amount (right-aligned under Amount column)
            // pdf.text(
            //     Number(allData.Bill_Amount || 0).toLocaleString("en-IN", {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }),
            //     197,
            //     y + 85,
            //     { align: "right" }
            // );


            // if (!isMarketCessApplicable) {
            //     pdf.setFont("Signika-Regular");
            //     pdf.setTextColor(0, 0, 0);

            //     pdf.text(`Market Cess : ${formatReadableAmount(allData.HeadMarketcess)}`, 12, y + 85);
            //     pdf.text(`Dekrekh Fee : ${formatReadableAmount(allData.DekhRekh)}`, 45, y + 85);
            // }

            let footerY = y + 12;
            const footerBottomLimit = pageHeight - 10;

            if (footerY > footerBottomLimit) {
                pdf.addPage();
                drawPageHeader();
                footerY = pageHeight - 10;
            }

            const pageCount = pdf.internal.getNumberOfPages();

            for (let i = 1; i <= pageCount; i++) {

                pdf.setPage(i);

                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                const footerY = pageHeight - 10;

                // ---- POWERED BY (left side) ----
                pdf.setFont("Signika-Medium");
                pdf.setFontSize(7);
                pdf.setTextColor(0, 0, 0);

                pdf.text("Powered by: Sugarian.app", 12, footerY);

                pdf.text("Authorised Signatory", 179, footerY - 20);

                // ---- PAGE INDEX (right side) ----
                pdf.text(
                    `Page ${i} of ${pageCount}`,
                    pageWidth - 20,
                    footerY,
                    { align: "right" }
                );
            }


            // pdf.setFont("Signika-Medium");
            // pdf.setFontSize(7);
            // pdf.setTextColor(0, 0, 0);
            // pdf.text("Powered by: Sugarian.app", 12, poweredByY);

            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfPreview(pdfUrl);
        };
    }

    return (
        <div id="pdf-content">
            {pdfPreview && (
                <PdfPreview
                    pdfData={pdfPreview}
                    apiData={invoiceData[0]}
                    label={"SaleBill"}
                />
            )}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Awak Print"} />
        </div>
    );
};
export default AwakentryReport;